export const GET_DASHBOARD_LIST= "GET_DASHBOARD_LIST";
export const GET_DASHBOARD_LIST_SUCCESS = "GET_DASHBOARD_LIST_SUCCESS";
export const GET_DASHBOARD_LIST_ERROR = "GET_DASHBOARD_LIST_ERROR";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

